export const META_ALLOW_ANONYMOUS_ACCESS = {anonymous: true} as const;
